import {isValidKey} from "../utils/functions";
import {RoleKey} from "./Keys";
import {HeadersCommon} from "./HeadersCommon";

const INITIAL_ROLE_HEADER_NAME = '担当';

export class RoleHeader {
    static readonly __CLASS__ = 'RoleHeader';

    private readonly key: RoleKey;
    private readonly name: string;

    constructor(key: RoleKey, name: string) {
        this.key = key;
        this.name = name;
    }

    get Key() {
        return this.key;
    }

    get Name() {
        return this.name;
    }

    withName(name: string) {
        return new RoleHeader(this.key, name);
    }

    static createDefault(role_key: RoleKey) {
        return new RoleHeader(role_key, INITIAL_ROLE_HEADER_NAME);
    }

    static from(origin: RoleHeader) {
        return new RoleHeader(origin.Key, origin.Name);
    }

    static fromJSON(object: any) {
        if (!isValidKey(object.key)) {
            throw new Error("invalid content_key");
        }
        if (typeof object.name !== 'string') {
            throw new Error("name must be string");
        }

        return new RoleHeader(
            object.key as RoleKey,
            object.name
        );
    }
}

export class RoleHeaders extends HeadersCommon<RoleHeader> {

    protected cloneHeader(original: RoleHeader): RoleHeader {
        return RoleHeader.from(original);
    }

    get Exists() {
        return 0 < this.Length
    }

    get LastHeader(): RoleHeader {
        if (this.Length === 0) {
            throw new Error('no role header');
        }
        return this.any_headers[this.Length - 1];
    }

    get GridTemplateRows() {
        return Array(this.Length).fill('32px').join(' ');
    }

    get Height() {
        return (this.Length === 0
            ? 0
            : (this.Length * (32 + 10)) - 10) + 'px';
    }

}
